import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequirePermission } from "@/components/universal/require-permission";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_admin/user")({
  component: UserAdminLayout,
});

function UserAdminLayout() {
  return (
    <RequirePermission
      permission="administrate_users"
      fallback={<NotFoundPage />}
    >
      <Outlet />
    </RequirePermission>
  );
}
